import moment from "moment";

import { checkUserId, getResponseQuery } from "../../helpers/_functions";
import http from "../../http-common";
import BaseService from "../base.service";

class SurveyRequest extends BaseService {
  constructor() {
    super("survey-requests");
  }

  upsertOne(requestBody) {
    return getResponseQuery(http.post(`${this.path}/upsert`, requestBody));
  }

  getByEnterprise(params = {}) {
    const enterpriseId = localStorage.getItem("enterpriseId");

    return getResponseQuery(
      http.get(`${this.path}/get-by-enterprise/${enterpriseId}`, {
        params
      })
    );
  }

  getDevelopmentPlanList(userId) {
    return getResponseQuery(
      http.get(`${this.path}/get-development-plan-list/${userId}`)
    );
  }

  getOverview(userId) {
    const params = {
      actualDate: moment().format("YYYY-MM-DD")
    };

    return getResponseQuery(
      http.get(`${this.path}/get-overview/${userId}`, {
        params
      })
    );
  }

  getByRespondent(respondent, params = {}) {
    return getResponseQuery(
      http.get(`${this.path}/get-by-respondent/${respondent}`, {
        params
      })
    );
  }

  getBySurveyType(surveyTypeId, params = {}) {
    return getResponseQuery(
      http.get(`${this.path}/get-by-survey-type/${surveyTypeId}`, {
        params
      })
    );
  }

  getDetailByRespondent(respondentId, params = {}) {
    return getResponseQuery(
      http.get(`${this.path}/get-detail-by-respondent/${respondentId}`, {
        params
      })
    );
  }

  getHistory(enterpriseId, params = {}) {
    params.userId = checkUserId();

    return getResponseQuery(
      http.get(`${this.path}/get-history/${enterpriseId}`, {
        params
      })
    );
  }

  /**
   *
   * @param {Object} options={} - options
   * @param {string} options.respondent - respondent
   * @param {string[]} options.limitDates - limitDates
   * @param {string} options.surveyType - surveyType
   * @param {string=} options.excludeId - excludeId
   */
  checkDuplication(options) {
    return getResponseQuery(
      http.post(`${this.path}/check-duplication`, options)
    );
  }
}

export default new SurveyRequest();
